import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Text, Button, Space, Conditional } from '@cashfree-intl/coherent';
import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';
import { getBankAccountDetailsAction } from 'containers/SettlementBankDetails/actions';
import saga from 'containers/SettlementBankDetails/saga';
import reducer from 'containers/SettlementBankDetails/reducer';
import { INTEGRATION_STATUS } from 'containers/CheckoutJourney/util/constant';
import { sendAnalyticsData } from 'containers/ProductTour/helper';
import { BankDetailProps, BankDetails, ConfirmBankDetailProps } from 'containers/CheckoutJourney/types';


const ConfirmBankDetail = ({ substep, updateStatus }: ConfirmBankDetailProps) => {
  useInjectReducer({ key: 'settlementBankDetails', reducer });
  useInjectSaga({ key: 'settlementBankDetails', saga, mode: '' });

  const dispatch = useDispatch();
  const [bankDetails, setBankDetails] = useState<BankDetails | null>(null);

  useEffect(() => {
    dispatch(
      getBankAccountDetailsAction({
        cb: (data: BankDetails[]) => {
          if (data?.length) {
            setBankDetails(data[0]);
          }
        },
      })
    );
  }, [dispatch]);

  const markAsDone = () => {
    updateStatus(substep.id, INTEGRATION_STATUS.COMPLETED);
    sendAnalyticsData("confirmSettlementBankDetailsButtonClicked");
  };

  const onClickWilldoLater = () => {
    updateStatus(substep.id, INTEGRATION_STATUS.PENDING);
  };

  return (
    <Space gap={2.5} direction="column" className="mt-2">
      <Space direction="row" className="pr-1" gap={4} style={{ maxWidth: '65%' }}>
        <Conditional if={!!bankDetails?.bankName}>
          <BankDetail label="Bank Name" value={bankDetails?.bankName} />
        </Conditional>
        <BankDetail label="Name" value={bankDetails?.accountHolder} />
        <BankDetail
          label="Account Number"
          value={bankDetails?.accountNumber ? `xxxxxxx${bankDetails.accountNumber.slice(-4)}` : null}
        />
        <BankDetail label="IFSC Code" value={bankDetails?.ifscCode} />
      </Space>

      <Space gap={1}>
        <Button primary onClick={markAsDone}>Looks Good</Button>
        <Button link onClick={onClickWilldoLater}>I will do later</Button>
      </Space>
    </Space>
  );
};


const BankDetail = ({ label, value }: BankDetailProps) => (
  <Space direction="column" alignItems="flex-start" className="py-1" gap={0.25}>
    <Text variant="p14" color="bodyLight">{label}</Text>
    {value ? <Text variant="p14" color="body">{value}</Text> : '-'}
  </Space>
);

export { ConfirmBankDetail };
